import { useCallback, useRef, useState } from "react";

const BeforeAfter = ({ before, after, alt = "" }) => {
  const [pos, setPos] = useState(50);
  const ref = useRef(null);
  const dragging = useRef(false);

  const update = useCallback((clientX) => {
    const rect = ref.current.getBoundingClientRect();
    const p = ((clientX - rect.left) / rect.width) * 100;
    setPos(Math.min(96, Math.max(4, p)));
  }, []);

  const onPointerDown = (e) => {
    dragging.current = true;
    update(e.clientX);
  };
  const onPointerMove = (e) => {
    if (dragging.current) update(e.clientX);
  };
  const stop = () => {
    dragging.current = false;
  };

  return (
    <div
      ref={ref}
      className="notch relative aspect-[16/9] w-full cursor-ew-resize select-none overflow-hidden"
      data-testid="before-after-slider"
      onPointerDown={onPointerDown}
      onPointerMove={onPointerMove}
      onPointerUp={stop}
      onPointerLeave={stop}
    >
      <img src={after} alt={`${alt} — po ułożeniu`} className="absolute inset-0 h-full w-full object-cover" draggable="false" data-testid="before-after-image-after" />
      <div className="absolute inset-0" style={{ clipPath: `inset(0 ${100 - pos}% 0 0)` }}>
        <img src={before} alt={`${alt} — przed ułożeniem`} className="h-full w-full object-cover" draggable="false" data-testid="before-after-image-before" />
        <span className="eyebrow absolute left-4 top-4 rounded-sm bg-ink/70 px-3 py-1.5">Przed</span>
      </div>
      <span className="eyebrow absolute right-4 top-4 rounded-sm bg-amber px-3 py-1.5 !text-ink">Po</span>

      <div className="absolute inset-y-0 w-0.5 bg-amber" style={{ left: `${pos}%` }}>
        <div className="absolute top-1/2 flex h-11 w-11 -translate-x-1/2 -translate-y-1/2 items-center justify-center rounded-full bg-amber text-ink shadow-[0_0_30px_rgba(255,184,0,0.5)]">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M8 7l-5 5 5 5M16 7l5 5-5 5" /></svg>
        </div>
      </div>
    </div>
  );
};

export default BeforeAfter;
